import React from 'react';

import { useEffectivePlatformPortal } from './hooks';

type PortalLogoProps = {
  fallback: React.ReactElement;
  width?: number;
  height?: number;
  compact?: boolean;
  variant?: 'regular' | 'contrast';
  alt?: string;
};

export default function PortalLogo({
  fallback,
  width = 135,
  height = 37,
  compact = false,
  variant = 'regular',
  alt,
}: PortalLogoProps) {
  const portal = useEffectivePlatformPortal();
  const logo =
    variant === 'contrast'
      ? portal?.contrast_logo || portal?.logo
      : portal?.logo;
  const logoUrl = logo?.url;

  if (!logoUrl) return fallback;

  const imageSize = compact
    ? { width, height }
    : { maxWidth: width, maxHeight: height };

  return (
    <img
      alt={alt || portal?.display_name || portal?.name || 'Platform logo'}
      src={logoUrl}
      style={{
        ...imageSize,
        display: 'block',
        objectFit: 'contain',
      }}
    />
  );
}
